import { Box } from "@mui/material" 
import { useContext } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { ToolContext } from "../../../core/context/ToolContext"
import { PreLoader } from "../../../core/loader/PreLoader"
import { Congratulation } from "./Congratulation"
import { TourPersonalization } from "./Tour"
import { Welcome } from "./Welcome"
import Cafgu from '../../../assets/images/svg/welcome-cafgu.svg';

export const Personalization = () => {
    let location = useLocation().pathname;
    const history = useHistory();
    const { loader_state, tool_state, personalization_state, profile_state } = useContext(ToolContext)
    const { __SESSION: {data: {ainfo}}, onboarding, noSidebar, isSteps } = {...tool_state, ...personalization_state}
    const uid = window.atob(ainfo.aid).split('_').pop()
    return (
        <Box>
            {
                location !== '/sso/account/auth' && location !== '/profile' && (
                    // onboarding.data.profiling ?
                    tool_state.__SESSION.data.pinfo.length === 0 ?
                        <Welcome history={history} onboarding={onboarding} noSidebar={noSidebar} Cafgu={Cafgu} tool_state={tool_state}/>
                    : ( tool_state.__SESSION.data.pinfo.length > 0  && location === '/'  && (
                            <Box>
                                {
                                    loader_state.isShow.data === true ?
                                        <PreLoader show={loader_state.isShow.data} />
                                    : (
                                        <Box>
                                            <Congratulation history={history} onboarding={onboarding} uid={uid} Cafgu={Cafgu} profile_state={profile_state} />
                                            <TourPersonalization isSteps={isSteps} onboarding={onboarding} uid={uid} />
                                        </Box>
                                    )
                                }
                            </Box>
                        )
                    )
                )
            }
        </Box>
    )
}